import http from './http';
import { EDUCATION_TYPE_SLUG } from '../config';
import notifier from '../_utils/notifier';


const cartAPI = {
  getOffers() {
    return http.get('cart/',{
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  deleteCartOffers(ids){
    return http.delete('cart/',  { params: { offers: ids } })
    .then(
      function(success) { return 'ok' },
      function(error) {
        notifier.alert(gettext('При удалении товаров произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  buyCartOffers(payload) {
    return http.post(`cart/buy/`, payload)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При покупке товаров произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  addOffersToCart(ids){
    return http.post('cart/', { offer: ids })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При добавлении товара в корзину произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  getPurchases(type) {
    if (type === EDUCATION_TYPE_SLUG){
      return http.get('education/purchases/')
      .then(
        function(success) { return success },
        function(error) {
          notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
        }
      )
    } else {
      if (type) {
        return http.get(`cart/purchases/${type}/`)
        .then(
          function(success) { return success },
          function(error) {
            notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
          }
        )
      }
      else {
        return http.get(`cart/purchases/`)
        .then(
          function(success) { return success },
          function(error) {
            notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
          }
        )
      }
    }
  },

  createPayment(id) {
    return http.post(`cart/create-payment/`, {'offer': id})
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При создании счета на покупку произошла ошибка. ') + '<br>' + error.messages);
        return error.messages;
      }
    )
  },

};


export default cartAPI;
